module.exports = __webpack_public_path__ + "img/guesheader-noti.6d75825e.svg";